// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"5b4788a8","455":"38bd5050","482":"0b3c7e14","544":"4bca0c3d","555":"e2dcad1e","708":"c4eca15f"}[chunkId] + ".chunk.js";
};